import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'

class Theatre extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			banner: null
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(id){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'theatre'
			}
		}).then( response => {
			this.setState({
				banner: response.data.banner
			})
		})
	}

	render() {
		return (
			<section className="container banner">
				<h2>About Our Theatre</h2>
				<Link to="/theatre">
					<img src={decodeURIComponent(this.state.banner)} alt="Our Theatre" />
				</Link>
			</section>
		)
	}
}

export default Theatre



// WEBPACK FOOTER //
// ./src/components/theatre.js